import React from 'react';
import { motion } from 'framer-motion';
const results = [{
  num: "01",
  title: "CALMA",
  desc: "Aprenderás herramientas para gestionar mejor el sobrepensamiento y recuperar claridad."
}, {
  num: "02",
  title: "SEGURIDAD",
  desc: "Comienza a reconstruir la confianza en ti y a depender menos de la validación externa."
}, {
  num: "03",
  title: "RELACIONES",
  desc: "Trabaja límites, dependencia emocional y patrones que pueden estar afectando tus vínculos."
}, {
  num: "04",
  title: "DIRECCIÓN",
  desc: "Vuelve a conectar con tus objetivos, propósito y acciones concretas para avanzar."
}];
export function Results() {
  return <section className="py-24 md:py-32 bg-ink relative" data-id="element-297" data-mp="1y2xk9i2tkpav">
      <div className="container mx-auto px-6" data-id="element-298" data-mp="1y3h0muctn5ms">
        <motion.div className="text-center max-w-4xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-299" data-mp="2c1x6kj2v0s3v">
          <h2 className="text-3xl md:text-5xl font-serif text-ivory-bright mb-6 leading-tight" data-id="element-300" data-mp="1m4vsxdc7q2mu">
            IMAGINA VOLVER A SENTIR QUE TIENES EL CONTROL DE TU VIDA.
          </h2>
          <div className="w-12 h-[1px] bg-gold mx-auto mt-8" data-id="element-301" data-mp="1w0fkjnjquf5s"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto" data-id="element-302" data-mp="211d7sejm1ze5">
          {results.map((result, index) => <motion.div key={index} className="bg-ink-light border border-white/5 p-8 md:p-10 rounded-2xl hover:border-gold/30 transition-colors duration-300 relative overflow-hidden group" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-303" data-mp="24zucysjh0zsx" data-mpi={index}>
              <div className="absolute top-0 right-0 p-6 opacity-10 group-hover:opacity-20 transition-opacity duration-300" data-id="element-304" data-mp="2sqzrn4dodm1n">
                <span className="font-serif text-6xl text-gold font-bold" data-id="element-305" data-mp="tnsv0eum1i1o">{result.num}</span>
              </div>
              
              <div className="relative z-10" data-id="element-306" data-mp="ophniarsfjmm">
                <div className="flex items-center gap-4 mb-4" data-id="element-307" data-mp="12fl5uqnjqt6s">
                  <span className="text-gold font-serif text-xl" data-id="element-308" data-mp="12gw82m1cfsvs">{result.num} —</span>
                  <h3 className="font-serif text-2xl text-ivory-bright tracking-wide" data-id="element-309" data-mp="xn1rvsky5w1g">{result.title}</h3>
                </div>
                <p className="text-muted font-light leading-relaxed text-lg" data-id="element-310" data-mp="17e4qmnqelyxk">{result.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}